// 端末固有 ID と localStorage ベースの送信履歴を管理
;(function () {
  const KEY_DEVICE_ID = 'deviceId';
  const KEY_SUBMIT_HISTORY = 'submitHistory';

  // 旧版 (Vue 2 + @capacitor/storage) は Web 環境でも 'CapacitorStorage.<key>'
  // というプレフィックス付きで localStorage に書いていた。 プレフィックス無しに
  // 移行したため、 旧版で送信済みの patient は履歴と端末 ID がリセットされる。
  // JSON 構造は同じなので、 初回だけ旧キーの値を新キーへコピーして旧キーを削除する。
  (function migrateCapacitorStorageKeys() {
    ['deviceId', 'submitHistory'].forEach((key) => {
      const oldKey = 'CapacitorStorage.' + key;
      const oldVal = localStorage.getItem(oldKey);
      if (oldVal == null) return;
      if (localStorage.getItem(key) == null) localStorage.setItem(key, oldVal);
      localStorage.removeItem(oldKey);
    });
  })();

  function getOrCreateDeviceId() {
    let deviceId = localStorage.getItem(KEY_DEVICE_ID);
    if (!deviceId) {
      deviceId = window.mixinUtils.uuidv4();
      localStorage.setItem(KEY_DEVICE_ID, deviceId);
    }
    return deviceId;
  }

  function getSubmitHistory() {
    try {
      const raw = localStorage.getItem(KEY_SUBMIT_HISTORY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      console.error('[deviceStore] submitHistory parse error', e);
      return {};
    }
  }

  function appendSubmitHistory(qName, answerId, labelFieldVal, time) {
    const hist = getSubmitHistory();
    if (!hist[qName]) hist[qName] = {};
    hist[qName][answerId] = { answerId, qName, time, labelFieldVal };
    localStorage.setItem(KEY_SUBMIT_HISTORY, JSON.stringify(hist));
    return hist;
  }

  function clearSubmitHistory() {
    localStorage.removeItem(KEY_SUBMIT_HISTORY);
  }

  // 旧版踏襲 (ModalSentHistory.vue:111-124): 現在の問診票 (qName) の履歴だけを削除する。
  // 他の問診票の履歴は残す。 hist[qName] が無ければ no-op。
  function removeSubmitHistoryForQName(qName) {
    const hist = getSubmitHistory();
    if (!hist[qName]) return hist;
    delete hist[qName];
    localStorage.setItem(KEY_SUBMIT_HISTORY, JSON.stringify(hist));
    return hist;
  }

  window.deviceStore = {
    getOrCreateDeviceId,
    getSubmitHistory,
    appendSubmitHistory,
    clearSubmitHistory,
    removeSubmitHistoryForQName,
    get deviceId() { return getOrCreateDeviceId(); }
  };
})();
